import { Slider } from '@material-ui/core';
import { Edit, NoteAddOutlined, Warning } from '@material-ui/icons';
import DeleteIcon from '@material-ui/icons/DeleteForeverOutlined';
import InfoIcon from '@material-ui/icons/HelpOutline';
import LockIcon from '@material-ui/icons/LockOpen';
import { Form } from '@sketchpixy/rubix';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import _ from 'lodash';
import moment from 'moment';
import React from 'react';
import { connect } from 'react-redux';
import { change, Field, reduxForm, submit } from 'redux-form';
import { BLUE, CARD_TYPES, ORANGE, PERMISSION_ENTITIES, PERMISSIONS, RED, SUBSCRIPTION_TYPES } from '../../_config/consts';
import { elaborateForbiddenDaysString, generateRandomNumber, hasFormWritePermission, isLockSupportingPIN } from '../../_config/utils';
import AbilityProvider from '../../permissionsUtils/AbilityProvider';
import * as UserActions from '../../redux/actions/user.actions';
import * as UtilsActions from '../../redux/actions/utils.actions';
import AccessProfilesIconCustom from '../CustomIcons/AccessProfilesIconCustom.jsx';
import SelectableRowField from './Fields/SelectableRows/SelectableRowField.jsx';
import CalendarClockIconCustom from '../CustomIcons/CalendarClockIconCustom.jsx';
import DiceIconCustom from '../CustomIcons/DiceIconCustom.jsx';
import ShareIconCustom from '../CustomIcons/ShareIconCustom.jsx';
import MDButton from '../MDButton/MDButton.jsx';
import CredentialTimeSelector from './Elements/CredentialTimeSelector.jsx';
import FormFlatContainer from './Elements/FormFlatContainer.jsx';
import LocksSelectorField from './Elements/LocksSelectorField.jsx';
import TagsSelectorListField from './Elements/TagsSelectorListField.jsx';
import CustomField from './Fields/CustomField.jsx';
import MDCheckBoxField from './Fields/MDCheckBox/MDCheckBoxField';
import MDSwitchField from './Fields/MDSwitch/MDSwitchField.jsx';
import GuestNoEmailForm from './GuestNoEmailForm.jsx';
import UserOutlineIconCustom from '../CustomIcons/UserOutlineIconCustom.jsx';
import PinIconCustom from '../CustomIcons/PinIconCustom.jsx';
import DefaultTimeProfileForm from './TimeProfiles/DefaultTimeProfileForm.jsx';


const marks = [
  {
    value: 4,
    label: '4',
  },
  {
    value: 5,
    label: '5',
  },
  {
    value: 6,
    label: '6',
  },
  {
    value: 7,
    label: '7',
  },
];
const validate = (values, props) => {
  const errors = {};
  if (values) {
    if (!values.deviceId) {
      errors.deviceId = 'required';
    } else if (values.deviceId && props.fixedPinLength && props.fixedPinLength !== String(values.deviceId).length) {
      errors.deviceId = 'pinLenghtMustBeMaxLenght';
    } else if (values.deviceId  && (values.deviceId.length < 4 || values.deviceId.length > 7)) {
      errors.deviceId = 'genericPINNumberInvalid';
    }
    if (!values.guestTags || (values.guestTags && _.isEmpty(values.guestTags))) {
      errors.guestTags = 'required';
    }

    if (!values.lockTags || (values.lockTags && _.isEmpty(values.lockTags))) {
      errors.lockTags = 'required';
    }


    if (!values.credentialTimeframe
        || !values.credentialTimeframe.startDate
        || !values.credentialTimeframe.endDate) {
      errors.credentialTimeframe = 'reservationDateIntevalErrorMessage';
    }
    
    if (values.credentialTimeframe && values.credentialTimeframe.endDate && moment(values.credentialTimeframe.endDate).isAfter('2099-12-31')) {
      errors.credentialTimeframe = 'errorEndDateTooBig';
    }
    
    if (!values.timeIntervalFrom) {
      errors.timeIntervalFrom = 'required';
    }

    if (!values.timeIntervalTo) {
      errors.timeIntervalTo = 'required';
    }
    if (values.timeIntervalTo && values.timeIntervalFrom) {
      const toTime = moment(values.timeIntervalTo);
      const fromTime = moment(values.timeIntervalFrom);
      const toDate = moment(0).hour(toTime.hour()).minute(toTime.minute()).second(0);
      const fromDate = moment(0).hour(fromTime.hour()).minute(fromTime.minute()).second(0);
      if (toDate.isSameOrBefore(fromDate)) {
        errors.timeIntervalTo = 'Interval not valid';
      }
    }
  }

  return errors;
};

const accessProfileOptions = [
  {},
  {
    id: -1,
    customOptionElement: (
      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: -5 }}>
        <Edit style={{ color: '#3f3f3f', marginRight: 10, fontSize: 22 }} />
        <h4 style={{ color: '#3f3f3f', fontWeight: 'bold' }}><Entity entity="customProfile" /></h4>
      </div>
    ),
  },
];

@reduxForm({ form: 'PinCredentialsForm', validate })
@connect(state => ({ form: state.form.PinCredentialsForm }))
class PinCredentialsForm extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      showGuestNoEmailForm: false,
      pinDigits: props.fixedPinLength ? props.fixedPinLength : 4,
    };
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(change('PinCredentialsForm', 'type', CARD_TYPES.ISEO_PIN));
  }

  componentDidUpdate(prevProps) {
    const { form, guestsFilteredByTags, accessProfilesData, onSelectAccessProfile } = this.props;
    const prevGuest = prevProps.guestsFilteredByTags && prevProps.guestsFilteredByTags.data && prevProps.guestsFilteredByTags.data[0];
    const currentGuest = guestsFilteredByTags && guestsFilteredByTags.data && guestsFilteredByTags.data[0];
    const prevAccessProfileId = prevGuest ? prevGuest.accessProfileId : null;
    const currentAccessProfileId = currentGuest ? currentGuest.accessProfileId : null;
    const isEditing = form && form.values && form.values.deviceBackendId;
    const hasProfileData = currentAccessProfileId && accessProfilesData && _.find(accessProfilesData, { id: currentAccessProfileId });
    if (
      !isEditing
      && currentAccessProfileId
      && currentAccessProfileId !== prevAccessProfileId
      && hasProfileData
      && onSelectAccessProfile
    ) {
      onSelectAccessProfile(currentAccessProfileId);
    }
  }

  onToggleShowGuestNoEmailForm(value) {
    this.setState({ showGuestNoEmailForm: value });
  }

  onChangePinLenght(pinDigits) {
    this.setState({ pinDigits })
  }

  onGenerateRandomPin() {
    const { dispatch } = this.props;
    const { pinDigits } = this.state;
    const newValue = generateRandomNumber(pinDigits);
    dispatch(change('PinCredentialsForm', 'deviceId', newValue));
  }

  onSubmitForm() {
    const { dispatch } = this.props;
    dispatch(submit('PinCredentialsForm'));
  }

  render() {
    const {
      form,
      availableLockTags,
      availableUserTags,
      onGuestTagsChange,
      onLockTagsChange,
      guestsFilteredByTags,
      locksFilteredByTags,
      onLockFilterModeChange,
      onGuestInputChange,
      onLockInputChange,
      onFetchMoreGuests,
      onFetchMoreLocks,
      onDeleteCard,
      onSavePinNotes,
      onSharePinWithCommunication,
      onSharePin,
      dispatch,
      onCreateAnonymousUserForPin,
      fixedPinLength,
      onInitializeNewTimeRange,
      is12HoursFormat,
      onSelectAccessProfile,
      accessProfilesData,
    } = this.props;
    const { showGuestNoEmailForm, pinDigits } = this.state;
    const notes = form && form.values && form.values.notes ? form.values.notes : '';
    const isEditing = form && form.values && form.values.deviceBackendId;
    const canDeleteStandardDevices = AbilityProvider.getAbilityHelper().hasPermission([PERMISSIONS.DELETE], PERMISSION_ENTITIES.STANDARD_DEVICE);
    const canReadUser = AbilityProvider.getAbilityHelper().hasPermission([PERMISSIONS.READ], PERMISSION_ENTITIES.USER);
    const guestTags = form && form.values && form.values.guestTags;
    const smartLocksSelected = form && form.values && form.values.selectedLocksTags;

    const locksHaveError = locksFilteredByTags && locksFilteredByTags[0] && locksFilteredByTags[0].data ? _.find(locksFilteredByTags[0].data, smartLock => !isLockSupportingPIN(smartLock)) : false;
    const isAccessProfilesActive = dispatch(UtilsActions.isAccessProfileAddonActive());
    const selectedGuestAccessProfileId = guestsFilteredByTags && guestsFilteredByTags.data && guestsFilteredByTags.data[0] ? guestsFilteredByTags.data[0].accessProfileId : null;
    const selectedGuestAccessProfile = selectedGuestAccessProfileId ? _.find(accessProfilesData, { id: selectedGuestAccessProfileId }) : null;
    const isUsingAccessProfile = form && form.values && form.values.accessProfileSelection && form.values.accessProfileSelection === selectedGuestAccessProfileId;
    if (selectedGuestAccessProfile && _.size(accessProfileOptions) <= 2) {
      accessProfileOptions[0] = {
        id: selectedGuestAccessProfile.id,
        customOptionElement: (
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: -5 }}>
            <AccessProfilesIconCustom style={{ color: '#3f3f3f', marginRight: 10, width: 22 }} />
            <h4 style={{ color: '#3f3f3f', fontWeight: 'bold' }}>{selectedGuestAccessProfile.name}</h4>
          </div>
        ),
      };
    }
    const isCommunicationPluginActive = dispatch(UserActions.userHasSubscriptions(SUBSCRIPTION_TYPES.COMMUNICATIONS));
    const hideGuestNoEmailSwitch = isEditing || !_.isEmpty(guestTags);
    const isPinLenghtFixed = fixedPinLength ? true : false;
    return (
      <Form>
        <FormFlatContainer
          title="pinData"
          iconButtonAction={() => onSharePin()} //onSharePinWithCommunication({ deviceId, dateFrom, dateTo })}
          iconButtonIcon={isEditing ? <ShareIconCustom style={{ width: 20, color: BLUE}} /> : null}
          icon={<PinIconCustom style={{ width: 22 }} />}
          containerStyle={{ marginRight: 10, marginTop: 0 }}
        >
          {isPinLenghtFixed ? (
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
              <Entity
                componentClass={Field}
                name="deviceId"
                componentAttribute="placeholder"
                entity="insertPinCode"
                title={<Entity entity="pinCodeUnlock" />}
                component={CustomField}
                errorExtraData={{ fixedPinLength }}
                helpText={isEditing ? null : <Entity entity="fixedPinHelpText" data={{ fixedPinLength }} />}
                textFormattingFunction={value => value.replace(/\s+/g, '').substring(0, fixedPinLength)}
                type="number"
                mandatory
                disabled={form && form.values && form.values.deviceBackendId}
              />
            <MDButton
              style={{ marginBottom: 15,  width: 'fit-content', marginTop: 0, alignSelf: 'flex-end' }}
              backgroundColor={BLUE}
              icon={<DiceIconCustom style={{ width: 20, marginLeft: 10 }} />}
              title={<Entity entity="generate" />}
              onClick={() => this.onGenerateRandomPin()}
            />
            </div>
            ) : (
            <Entity
              componentClass={Field}
              name="deviceId"
              componentAttribute="placeholder"
              entity="insertPinCode"
              title={<Entity entity="pinCodeUnlock" />}
              component={CustomField}
              helpText={isEditing ? null : <Entity entity="cardFieldHelpText" data={{ type: CARD_TYPES.ISEO_PIN }} />}
              textFormattingFunction={value => value.replace(/\s+/g, '')}
              type="number"
              mandatory
              disabled={form && form.values && form.values.deviceBackendId}
            />
          )}
          {!isEditing && !isPinLenghtFixed ? (
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: 5, marginLeft: 3 }}>
              <div style={{ width: '50%' }}>
                <h5 style={{ fontWeight: 'bold', fontSize: 16 }}><Entity entity="numberOfDigits" /></h5>
                  <div style={{ paddingLeft: 10 }}>
                    <Slider
                      step={1}
                      min={4}
                      max={7}
                      value={pinDigits}
                      marks={marks}
                      aria-label="Large"
                      onChange={(e, value) => this.onChangePinLenght(value)}
                    />
                  </div>
              </div>
              <MDButton
                style={{ marginLeft: 20, width: 'fit-content', marginTop: 10 }}
                backgroundColor={BLUE}
                icon={<DiceIconCustom style={{ width: 20, marginLeft: 10 }} />}
                title={<Entity entity="generate" />}
                onClick={() => this.onGenerateRandomPin()}
              />
            </div>
          ) : null}
        </FormFlatContainer>
        <FormFlatContainer
          title="cardDescription"
          subtitle="cardDescriptionSubtitle"
          containerStyle={{ marginRight: 10 }}
          icon={<NoteAddOutlined style={{ fontSize: 22 }} />}
        >
          <Entity
            componentClass={Field}
            name="notes"
            componentAttribute="placeholder"
            entity="insertCardDescription"
            component={CustomField}
            type="textarea"
            disabled={!hasFormWritePermission(PERMISSION_ENTITIES.STANDARD_DEVICE, isEditing)}
            className="form-control-custom"
          />
          {isEditing && hasFormWritePermission(PERMISSION_ENTITIES.STANDARD_DEVICE, isEditing) && (
            <MDButton
              title={<Entity entity="saveNotes" />}
              backgroundColor={BLUE}
              onClick={() => onSavePinNotes(notes)}
            />
          )}
        </FormFlatContainer>
        <FormFlatContainer
          title="cardTagGuestTitle"
          subtitle="cardTagGuestSubtitle"
          containerStyle={{ marginRight: 10 }}
          icon={<UserOutlineIconCustom style={{ width: 22 }} />}
        >
          <TagsSelectorListField
            name="guestTags"
            formName="PinCredentialsForm"
            selectedTagsFieldName="selectedGuestTags"
            tags={availableUserTags}
            selectedTags={guestsFilteredByTags}
            form={form}
            tagsType="GUEST"
            title="guestTagsCard"
            placeholder="insertGuestTagsForCard"
            listTitle="selectedUsers"
            emptyTagSelectionText={canReadUser ? 'noUsersForSelectedTag' : null}
            onFetchMoreItems={page => onFetchMoreGuests(page)}
            onTagsChange={values => onGuestTagsChange(values)}
            onInputChange={value => onGuestInputChange(value)}
            isSingleChoice
            disabled={!hasFormWritePermission(PERMISSION_ENTITIES.STANDARD_DEVICE, isEditing)}
          />
          {hideGuestNoEmailSwitch ? null : (
            <Field
              name="withoutEmail"
              label={<Entity entity="createNewUserForPIN" />}
              titleStyle={{ fontSize: 16, color: '#3f3f3f', fontWeight: 'bold' }}
              containerstyle={{ marginTop: 10 }}
              component={MDSwitchField}
              activeText="createNewUserForCardWarning"
              activeTextIcon={<Warning style={{ color: ORANGE, marginRight: 10, marginTop: 0, fontSize: 20 }} />}
              onHandleChange={value => this.onToggleShowGuestNoEmailForm(value)}
            />
          )}
          {showGuestNoEmailForm && !hideGuestNoEmailSwitch ? (
            <div>
              <GuestNoEmailForm
                onSubmit={(guestData) => onCreateAnonymousUserForPin(guestData)}
              />
              <MDButton
                title={<Entity entity="createUser" />}
                backgroundColor={BLUE}
                disabled={!hasFormWritePermission(PERMISSION_ENTITIES.USER, isEditing)}
                onClick={() => dispatch(submit('GuestNoEmailForm'))}
              />
            </div>
          ) : null}
        </FormFlatContainer>
        <FormFlatContainer
          title="defaultTimeProfileTitle"
          subtitle="defaultTimeProfileSubtitle"
          containerStyle={{ marginRight: 10 }}
          icon={<CalendarClockIconCustom style={{ width: 22 }} />}
        >
          {selectedGuestAccessProfile && isAccessProfilesActive ? (
            <div>
              <h4 style={{ color: '#3f3f3f', fontWeight: 'bold', marginBottom: 0, marginTop: 20 }}>{<Entity entity="selectAccessProfileOrCustom" />}</h4>
              <Field
                name="accessProfileSelection"
                component={SelectableRowField}
                onHandleChange={value => onSelectAccessProfile(value)}
                isSingleChoice
                rowStyle={{ maxHeight: 55, maxWidth: '80%' }}
                options={{
                  content: accessProfileOptions,
                }}
                listContainerStyle={{ marginTop: 0 }}
                listStyle={{ marginTop: 0 }}
              />
            </div>
          ) : null}
            <DefaultTimeProfileForm
              formData={form && form.values}
              form={form}
              formName="PinCredentialsForm"
              is12HoursFormat={is12HoursFormat}
              onInitializeNewTimeRange={(timeRangeId, fieldName) => onInitializeNewTimeRange(timeRangeId, fieldName)}
              areDeviceDatesLocked={false}
              canEdit={hasFormWritePermission(PERMISSION_ENTITIES.STANDARD_DEVICE, isEditing) && !isUsingAccessProfile}
              availableLockTags={availableLockTags}
              locksFilteredByTags={locksFilteredByTags && locksFilteredByTags[0]}
              onFetchMoreLocks={page => onFetchMoreLocks(page)}
              onLockTagsChange={values => onLockTagsChange(values)}
              onLockInputChange={value => onLockInputChange(value)}
              lockHasErrorCondition={lock => !isLockSupportingPIN(lock)}
              locksHaveError={locksHaveError}
              lockErrorMessageCustom="selectedLocksPINIncompatibleError"
              onLockFilterModeChange={values => onLockFilterModeChange(values)}
            />
        </FormFlatContainer>
        {isCommunicationPluginActive && !isEditing ? (
          <FormFlatContainer title="sharePinInformation" subtitle="sharePinInformationDescription" containerStyle={{ marginRight: 10 }} icon={<ShareIconCustom style={{ width: 20 }} />}>
            <Field
              name="sharePinWithCommunication"
              label={<Entity entity="sharePinAfterCreation" />}
              titleStyle={{ fontSize: 16, color: '#3f3f3f' }}
              component={MDCheckBoxField}
            />
          </FormFlatContainer>
        ) : null}
        {hasFormWritePermission(PERMISSION_ENTITIES.STANDARD_DEVICE, isEditing) && (
          <div style={{ backgroundColor: 'white', position: 'absolute', left: 0, right: 0, bottom: 0, width: '100%', margin: 0 }}>
            <MDButton
              title={<Entity entity="save" />}
              containerStyle={{ position: 'absolute', left: 0, right: 0, bottom: 0, width: '100%', margin: 0 }}
              style={{ height: 45, borderRadius: 0 }}
              disabled={locksHaveError}
              onClick={() => this.onSubmitForm()}
            />
          </div>
        )
        }
        {onDeleteCard && canDeleteStandardDevices && (
          <FormFlatContainer
            title="deleteCredential"
            subtitle="deleteCredentialCardWarning"
            containerStyle={{ marginRight: 10 }}
            icon={<DeleteIcon style={{ fontSize: 24 }} />}
          >
            <MDButton
              title={<Entity entity="deletePinCode" />}
              backgroundColor={RED}
              onClick={() => onDeleteCard()}
            />
          </FormFlatContainer>
        )}
      </Form>
    );
  }
} 

export default PinCredentialsForm;
